import { FC, useCallback, useContext } from 'react';
import { useUserIsLogged } from '@common/selectors/user.selectors';
import { SlideDownBox } from '../slideDownBox/slideDownBox';
import { trans } from '../../modules/translation/translate';
import { NotificationIcon } from '../notificationIcon/NotificationIcon';
import { SettingsLayoutContext } from './SettingsLayout.context';
import { SettingsLayoutSection } from './settingsLayout';

const SlideDownBoxElement: FC<SettingsLayoutSection> = (section) => {
	const {
		id,
		name,
		nameComponent,
		notification,
		isActive,
		isLogged,
		isNarrow,
	} = section;

	const { activeId, getSectionContent, handleChangeSection } = useContext(
		SettingsLayoutContext,
	);

	const isLogged_ = useUserIsLogged();

	const content = useCallback(
		() => getSectionContent(id, undefined, isNarrow),
		[getSectionContent, id, isNarrow],
	);

	const callback = useCallback(
		(isVisible) => {
			if (isVisible) {
				handleChangeSection(section);
			}
		},
		[section, handleChangeSection],
	);

	return (isActive && !isActive()) || (!isLogged_ && isLogged) ? null : (
		<SlideDownBox
			key={id}
			name={`settings-${id}`}
			Title={() => (
				<span
					className={`settings__button ${id} ${
						id === activeId ? 'active' : ''
					}`}
				>
					<span className="relative">
						{name && <>{trans({ label: name() })} </>}
						{nameComponent && <>{nameComponent()} </>}
						{!!notification && <NotificationIcon notification={notification} />}
					</span>
				</span>
			)}
			Content={content}
			callback={callback}
			isContentInitVisible={id === activeId}
			isContentVisible={id === activeId}
		/>
	);
};

export const SettingsLayoutMobile: FC = () => {
	const { sections } = useContext(SettingsLayoutContext);
	return <>{sections.map(SlideDownBoxElement)}</>;
};
